import React from 'react';
import styled, { css } from 'styled-components';
import { minBreakpointQuery, sectionMargins, brandColours } from '../styles';
import { Container, Heading, Button, HtmlContent } from './ui';

const StyledHighlightedContent = styled.section`
  ${sectionMargins('30px', '70px')}
`;

const StyledInner = styled.div`
  padding: 30px 25px;
  background-color: ${brandColours.quaternary};

  ${({ centered }) => {
    if (centered) {
      return css`
        text-align: center;
      `;
    }
  }}

  ${minBreakpointQuery.small`
    padding: 40px;
  `}

  ${minBreakpointQuery.medium`
    padding: 60px;
  `}

  ${minBreakpointQuery.large`
    padding: 80px;
  `}
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;

  ${minBreakpointQuery.medium`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.mlarge`
    margin-bottom: 30px;
  `}
`;

const StyledContent = styled(HtmlContent)``;

const StyledSubheading = styled.h3`
  margin-top: 20px;

  ${minBreakpointQuery.medium`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.mlarge`
    margin-top: 30px;
  `}
`;

const StyledButton = styled(Button)`
  margin-top: 25px;

  ${minBreakpointQuery.medium`
    margin-top: 30px;
  `}

  ${minBreakpointQuery.mlarge`
    margin-top: 35px;
  `}
`;

const HighlightedContent = ({
  heading,
  text,
  subHeading,
  button,
  centered,
  altHeading,
}) => (
  <StyledHighlightedContent>
    <Container>
      <StyledInner centered={centered}>
        <StyledHeading alt={altHeading}>{heading}</StyledHeading>
        {text && (
          <StyledContent
            html={text.startsWith('<p>') ? text : `<p>${text}</p>`}
          />
        )}
        {subHeading && <StyledSubheading>{subHeading}</StyledSubheading>}
        {button && (
          <StyledButton to={button.url} alt={true}>
            {button.text}
          </StyledButton>
        )}
      </StyledInner>
    </Container>
  </StyledHighlightedContent>
);

export default HighlightedContent;
